import { Toaster as SonnerToaster } from "sonner";

/**
 * Toaster — sonner with brand theming.
 * Mounted once in main.tsx next to RouterProvider.
 * Tones: success (--success), info (--primary), warning (--warning),
 *        error (--destructive). Border-left 3px accent per design spec.
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      richColors
      expand
      visibleToasts={3}
      toastOptions={{
        classNames: {
          toast: [
            "group flex items-start gap-3 w-full rounded-[var(--radius-lg)]",
            "border border-[var(--border)] bg-[var(--card)]",
            "shadow-[var(--shadow-lg)] px-4 py-3 text-sm",
            "text-[var(--foreground)]",
          ].join(" "),
          title: "font-semibold text-sm text-[var(--foreground)]",
          description: "text-xs text-[var(--muted-foreground)] mt-0.5",
          actionButton:
            "rounded-md px-3 py-1 text-xs font-medium bg-[var(--primary)] text-[var(--primary-foreground)]",
          cancelButton:
            "rounded-md px-3 py-1 text-xs font-medium bg-[var(--muted)] text-[var(--muted-foreground)]",
          closeButton:
            "text-[var(--muted-foreground)] hover:text-[var(--foreground)] transition-colors",
          success: "border-l-4 border-l-[var(--success)]",
          error: "border-l-4 border-l-[var(--destructive)]",
          warning: "border-l-4 border-l-[var(--warning)]",
          info: "border-l-4 border-l-[var(--primary)]",
        },
      }}
    />
  );
}
